<template>
  <form @submit.prevent="onsubmit" class="login">
    <div class="row mb-2 recover-password__intro">
      Enter your email to receive a link to reset your password
    </div>
    <div class="row mb-2">
      <va-input
        v-model="email"
        type="email"
        :label="$t('auth.email')"
        :error="!!emailErrors.length"
        :error-messages="emailErrors"
      />
    </div>

    <div class="row justify--center">
      <va-button type="submit" class="my-0">{{ $t('auth.reset_password') }}</va-button>
    </div>
    <div class="row recover-password__msg" >
      <span v-if="showSent">
      An email has been sent with further instructions.
      </span>
    </div>
    <div class="auth-layout__options d-flex align--center justify--space-between">
      <router-link class="ml-1 link" :to="{name: 'login'}">Back to Login</router-link>
    </div>
  </form>
</template>

<script>
import hiqapi from '@/hiqapi/hiqapi'

export default {
  name: 'recover-password',
  data() {
    return {
      email: '',
      emailErrors: [],
      showSent: false,
    }
  },
  methods: {
    async onsubmit() {
      if (!this.email) {
        this.emailErrors = ['Email is required']
      } else {
        this.showSent = true
        this.emailErrors = []

        let resp = await hiqapi.postPutWait('post', '/users/password_reset', { 'email': this.email })
        console.log('BACK resp=', resp)
      }
    },
  },
}
</script>

<style lang="scss">
.recover-password {
  &__intro {
    padding-bottom: 30px;
  }
  &__msg {
    margin-top: 30px;
    margin-bottom: 20px;
  }
}
</style>
